// jQuery_T4NT(document).ready(function($) {

//      /**
//      *  Variant selection changed
//      *  data-variant-toggle="{{ variant.id }}"
//      */
//     $( document ).on( "variant:changed", function( evt ) {
//       // console.log( evt.currentVariant );
//       // $('[data-variant-toggle]').hide(0);
//       // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
//     });
   
// });
$(document).ready(function() {
  // $(".popform-box .btn-close svg").click(function(){
  // $("#popForm").css("display","none");
  // })
  
  // $(".btn-quote").click(function(){
  //  $("#popForm").css("display","block");
  // })

  //  $(".btn-product-form").click(function(){
  //  $("#popForm").css("display","block");
  // })


    $(".btn-more").click(function(e) {
    e.preventDefault();
    var show=$(this).parent().siblings(".text-content").find(".content");
    show.toggleClass("expand");

    if (show.hasClass("expand")) {
      $(this).text("Collapse");
    } else {
      $(this).text("View More");
    }
  });

    const mask = document.querySelector('#popForm');
        mask.addEventListener('wheel', (event) => {
        event.stopPropagation();
    });
  

})